import { application } from './application';
import ChartingFormController from './charting_form_controller';
import ChartingButtonController from './charting_button_controller';
import ChartingToggleController from './charting_toggle_controller';
import ChartingSelectController from './charting_select_controller';
import ChartingSearchController from './charting_search_controller';
import ChartingDatePickerController from './charting_date_picker_controller';
import ChartingDateRangeController from './charting_date_range_controller';
import ChartingNumberRangeController from './charting_number_range_controller';
import ChartingCheckboxGroupController from './charting_checkbox_group_controller';
import ChartingDatatableController from './charting_datatable_controller';
import ChartingModalController from './charting_modal_controller';
import ChartingChatController from './charting_chat_controller';
import ChartingChatComposerController from './charting_chat_composer_controller';
import ChartingChatScreenshotController from './charting_chat_screenshot_controller';
import ChartingChatDraggableController from './charting_chat_draggable_controller';
import './charts';

application.register('charting-form', ChartingFormController);
application.register('charting-button', ChartingButtonController);
application.register('charting-toggle', ChartingToggleController);
application.register('charting-select', ChartingSelectController);
application.register('charting-search', ChartingSearchController);
application.register('charting-date-picker', ChartingDatePickerController);
application.register('charting-date-range', ChartingDateRangeController);
application.register('charting-number-range', ChartingNumberRangeController);
application.register('charting-checkbox-group', ChartingCheckboxGroupController);
application.register('charting-datatable', ChartingDatatableController);
application.register('charting-modal', ChartingModalController);
application.register('charting-chat', ChartingChatController);
application.register('charting-chat-composer', ChartingChatComposerController);
application.register('charting-chat-screenshot', ChartingChatScreenshotController);
application.register('charting-chat-draggable', ChartingChatDraggableController);
